// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './regions-api';

export const useListRegions: typeof hookExports.useListRegions = hookExports.useListRegions;
export const useLazyListRegions: typeof hookExports.useLazyListRegions =
  hookExports.useLazyListRegions;
export const useCreateRegion: typeof hookExports.useCreateRegion = hookExports.useCreateRegion;
export const useGetRegion: typeof hookExports.useGetRegion = hookExports.useGetRegion;
export const useLazyGetRegion: typeof hookExports.useLazyGetRegion = hookExports.useLazyGetRegion;
export const useUpdateRegion: typeof hookExports.useUpdateRegion = hookExports.useUpdateRegion;
export const useDeleteRegion: typeof hookExports.useDeleteRegion = hookExports.useDeleteRegion;
export const useListRegionIps: typeof hookExports.useListRegionIps = hookExports.useListRegionIps;
export const useLazyListRegionIps: typeof hookExports.useLazyListRegionIps =
  hookExports.useLazyListRegionIps;
export const useCreateRegionIp: typeof hookExports.useCreateRegionIp =
  hookExports.useCreateRegionIp;
export const useUpdateRegionIp: typeof hookExports.useUpdateRegionIp =
  hookExports.useUpdateRegionIp;
export const useDeleteRegionIp: typeof hookExports.useDeleteRegionIp =
  hookExports.useDeleteRegionIp;
